/* eslint-disable @typescript-eslint/no-explicit-any */
export const getNestedValue = (obj: object, path: string, defaultValue: unknown = undefined): any => {
  const travel = (regexp: RegExp): any =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? (res as any)[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};
